import request from './axios';

// 操作记录相关 API
export default {
  // 获取操作记录列表
  getOperationLogs(params) {
    return request({
      url: '/manage/operation-logs',
      method: 'get',
      params,
    });
  },
  
  // 获取操作记录详情
  getOperationLogDetail(id) {
    return request({
      url: `/manage/operation-logs/${id}`,
      method: 'get',
    });
  },
  
  // 删除操作记录
  deleteOperationLog(id) {
    return request({
      url: `/manage/operation-logs/${id}`,
      method: 'delete',
    });
  },
  
  // 清空操作记录
  clearOperationLogs() {
    return request({
      url: '/manage/operation-logs/clear',
      method: 'delete',
    });
  },
};